import React from 'react';
import './App.scss';
import MainPage from '../components/MainPage/MainPage';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <MainPage />
      </div>
    );
  }
}

export default App;
